import "../../styles/pageskelton.css";
import SkeletonBox from "./SkeletonBox";

const BlogSkeleton = () => (
  <div className="sk-page">
    <SkeletonBox className="sk-header" />
    <SkeletonBox className="sk-inner-hero" />

    <div className="conatiner">
      {/* Featured post */}
      <div className="sk-blog-featured">
        <SkeletonBox className="sk-blog-featured-img" />
        <div className="sk-blog-featured-text">
          <SkeletonBox className="sk-blog-line-sm" />
          <SkeletonBox className="sk-blog-line-lg" />
          <SkeletonBox className="sk-blog-line-lg" style={{ width: "75%" }} />
          <SkeletonBox className="sk-blog-line-md" />
          <SkeletonBox className="sk-blog-line-md" />
          <SkeletonBox className="sk-blog-line-md" style={{ width: "60%" }} />
          <SkeletonBox className="sk-box" style={{ height: 44, width: 140, borderRadius: 8, marginTop: 8 }} />
        </div>
      </div>

      {/* Card grid */}
      <div className="sk-blog-grid">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <div key={i}>
            <SkeletonBox className="sk-blog-card-img" />
            <SkeletonBox className="sk-blog-card-line" style={{ width: "40%" }} />
            <SkeletonBox className="sk-blog-card-line" />
            <SkeletonBox className="sk-blog-card-line" style={{ width: "80%" }} />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default BlogSkeleton;
